import React from 'react';
import FallbackComponent from './FallbackComponent';

const SuspenseFallback = () => {
  return <FallbackComponent />;
};

export default SuspenseFallback;
